import { render } from "./EventsCard.vue?vue&type=template&id=f1292274"
import script from "./EventsCard.vue?vue&type=script&lang=js"
export * from "./EventsCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dotter/dotter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__